<template>
  <div class="link-list-accordions">
    <div 
      class="link-list-accordion"
      v-for="(list, i) in lists"
      :key="i"
      :id="uID(i)"
    >
      <h3>
        <button 
          type="button"
          :id="uID(i) + '_btn'"
          @click="toggleAccordion(uID(i))"
          :class="{ active : open === uID(i) }"
          :aria-expanded="open === uID(i) ? 'true' : 'false'"
          :aria-controls="panelID(i)"
          data-sssss="ffff"
        >
          {{ list.header.name }}
          <i class="far fa-chevron-down" aria-hidden></i>
        </button>
      </h3>

      <LinkList 
        :id = "panelID(i)"
        role="region"
        :aria-labelledby="uID(i) + '_btn'"
        :aria-hidden="open !== uID(i)"
        :class="{ active : open === uID(i) }"
        :links="links(list.header, list.links)" 
        :unstyle="true" 
      />
    </div>
  </div>
</template>

<script>
  import LinkList from './LinkList.vue'

  export default {
    name: 'LinkListAccordion',
    props: {
      lists: Array,
      addHeaderToLinks: Boolean,
      idPrefix: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        open: '',
      }
    },
    components: {
      LinkList
    },
    methods: {
      toggleAccordion(accordion) {
        this.open = (this.open === accordion) ? '' : accordion
      },
      uID(index) {
        return this.idPrefix + 'link-list-accordion_' + index
      },
      panelID(index) {
        return this.uID(index) + '_panel'
      },
      links(header, list) {
        if (this.addHeaderToLinks && header.url) {
          let link = {...header}
              link.name = 'All ' + link.name
              link.title = 'All ' + link.title
              link.link = 'All ' + link.link
          return [link, ...list]
        } else {
          return list
        }
      }
    },
  }
</script>

<style lang="scss">
  .link-list-accordion {
    border-bottom: 1px solid #ccc;

    h3 {
      font-family: 'Open Sans', sans-serif, Arial;
      font-size: 1em;
      font-weight: normal;
      margin:0;
      display: flex;
    }

    button {
      background: #fff;
      width: 100%;
      text-align: left;
      display: grid;
      grid-template-columns: 1fr 10px;
      align-items: center;
      padding: 15px 20px;
      border: 0px;

      &.active .fa-chevron-down {
        transform: rotate(180deg);
      }
    }

    a {
      padding: 10px 10px 10px 35px;
      width: 100%;
      display: block;
      color: #000;
    }

    ul { 
      overflow: hidden;
      max-height: 0;
      transition: max-height .2s ease-in-out, visibility 1s;
      visibility: hidden;

      &.active {
        max-height: 1000px;
        visibility: visible;
        transition: max-height .4s ease-in-out, visibility 0s;
      }
    }
  }
</style>
